export interface ProgressBarProps {
  pct: number;
  color: string;
  height?: number;
  radius?: number;
  trackColor?: string;
  margin?: string;
}

export default function ProgressBar({
  pct,
  color,
  height = 7,
  radius = 4,
  trackColor = '#E2E8F0',
  margin = '8px 0 6px',
}: ProgressBarProps): JSX.Element {
  const safePct = Math.min(Math.max(Number(pct) || 0, 0), 100);
  return (
    <div
      style={{ height, borderRadius: radius, background: trackColor, overflow: 'hidden', margin }}
    >
      <div
        style={{
          width: `${safePct}%`,
          height: '100%',
          background: color,
          borderRadius: radius,
          transition: 'width 0.3s',
        }}
      />
    </div>
  );
}
